// extracted by mini-css-extract-plugin
export default {"nav":"HotelBookStatus_nav__FBPK6","total":"HotelBookStatus_total__iSXcB","ul":"HotelBookStatus_ul__Wvx3E","menu":"HotelBookStatus_menu__GFLLY"};